import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Navbar />
      <Link to="/Notes" id="back">
        <Button
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <h1 id='desc' style={{ textAlign: "center" }}>Sixth sem CSE/ISE Notes</h1>

      <ExpansionPanel
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        style={{ marginTop: "40px" }}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>CNS</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              Notes <br />
              <a href="https://drive.google.com/file/d/1yCFu_XzEsU5idW2E8nXTceAj0xp0v3kA/view?usp=sharing">
                Mod 1
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1ok43IDcxHNzYtSvmV7mpnSKIvhx402Km/view?usp=sharing">
                Mod 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1oF8UG1_cpGren_XrkDeDQ8C9jl7DNW0J/view?usp=sharing">
                Mod 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1JyAMXFbiy7gcG-1ANVUrW1z6aRy3Q00c/view?usp=sharing">
                Mod 4{" "}
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1gpgnOQOxJas7-nG_9Kb7caFNBdgaz7_G/view?usp=sharing">
                Mod 5{" "}
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
              Classroom notes <br />
              <a href="https://drive.google.com/file/d/19TjAFFtgDyAlSKLtIMO8YyMjjj8Pyqau/view?usp=sharing">
                Mod 1
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1REBzcer3beXCpSHmnPZ9UlveVuWA5wAk/view?usp=sharing">
                Mod 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1_bIdWEpQIdwBXQayR3Mt0mzR6kRoi5Un/view?usp=sharing">
                Mod 3
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ildLZQStiKjFZkYb_0D5SsDksqlaJi1s/view?usp=sharing"
                target="_blank"
              >
                Mod 1 Summary
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/14ivbKT0bz8VHsK-nF-0T0-TlwymQbFZV/view?usp=sharing"
                target="_blank"
              >
                Mod 2 Summary
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1yvLScJAAoYcmBSiq2rxeAZ1Fq_O-xIvO/view?usp=sharing"
                target="_blank"
              >
                Mod 3 Summary
              </a>
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B07GB2CW1V&asins=B07GB2CW1V&linkId=fc18e3ea1fdbf8cb0026f220591fa69b&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>

              <br />
            </div>
          </Typography>

        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>CG</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            {" "}
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/18Plv6ClWHXZ2LXDDJRvLpZhzZ9hPJ1Jc/view?usp=sharing">
                Mod 1{" "}
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1aHU9hBMvLOMAUWq9Q37F4TtuHmsiV587/view?usp=sharing">
                Mod 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/17Xt3NqvfMfch2fPQjoVmrcrusZxzObEB/view?usp=sharing">
                Mod 3{" "}
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1Msb_VIM0iZoki3RByVLYqBXGbAVb8vDR/view?usp=sharing">
                Mod 4{" "}
              </a>
              <br />
              <a href="https://drive.google.com/file/d/13fgEfx_Dtp3nHxfPaPGcAb2rZAQPrVQp/view?usp=sharing">
                Mod 5{" "}
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>

              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=9332518718&asins=9332518718&linkId=83fb359ed6483ab2c0ba4a87873dba9d&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=8131797252&asins=8131797252&linkId=b3b103dfe58e15ed0addacf4077218e8&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.heading}>OS</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              Notes <br />
              <a href="https://drive.google.com/file/d/10YMLHhi0UJwoSwVn85sezShgp0nGriKU/view?usp=sharing">
                Mod 1{" "}
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1GfgvjndYFjlrjaRWVIXIS-0QX-65nHj_/view?usp=sharing">
                Mod 2{" "}
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1vSplLnNYxCB1OfP-frbeY1c98zkv3p9r/view?usp=sharing">
                Mod 3{" "}
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1MDdlr9pa2KbYuuXARCXivsQqCpekxYMT/view?usp=sharing">
                Mod 4{" "}
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1qWsoBIEFOisPlTaE80-FT4VYDL4iav--/view?usp=sharing">
                Mod 5{" "}
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
              Solved Paper <br />
              <a
                href="https://drive.google.com/file/d/1XHNiHLH1c30Sv94l2KPfntmvkmrA3gDv/view?usp=sharing"
                target="_blank"
              >
                Module 1 solved Q&N
              </a>
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>


              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B074G46V8F&asins=B074G46V8F&linkId=8ca8eff71baba3be4ac78328cac16e7f&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>OR</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            {" "}
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <b style={{ color: "black" }}>

              </b>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1hYiOC7WXmj00gK_VA-e7jestNT2-cECE/view?usp=sharing">
                Module 1
              </a>
              <br />

              <a href="https://drive.google.com/file/d/1ltJyJVNQ3gPRqQhQFP2jcVyYEQhDO_c4/view?usp=sharing">
                Module 2
              </a>
              <br />

              <a href="https://drive.google.com/file/d/1MpZefBZvLPFgVlBFh2nbvD1PdR7UAr_q/view?usp=sharing">
                Module 3
              </a>
              <br />

              <a href="https://drive.google.com/file/d/1O2LO-U6vZFaOETXOy7BEF5qQhaSirWxi/view?usp=sharing">
                Module 4
              </a>
              <br />

              <a href="https://drive.google.com/file/d/1tUPk2Jh1F7v_rNkIwLda-7nNe87VmIQJ/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B01G6ZZO76&asins=B01G6ZZO76&linkId=234761b8aafd5998546ba2cadfff1ea2&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>Python</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            {" "}
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1X66iXbNktjUDbOhNkU2_4N-VKvB2iXhE/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1j_V4TCl9Ay5D5fc_eeK217Law-PW08eG/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1DMlI9Nw-y1fKED5n1vjCvYx-wDGkguXv/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1GRoyQupnTRQcAW-_HhKnbieq142aAUpt/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1DAfiYPlPPwRxqdB_lGMhDN-YuRsykX7x/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>

              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=1530051126&asins=1530051126&linkId=c2f32017acd45e810537b3497fc7b067&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=1491939362&asins=1491939362&linkId=146a5dc7368126265d0d3d89fd14ee9c&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>SS & CD</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              Notes <br />
              <a href="https://drive.google.com/file/d/1NLaWXavOJgRisLhjqwj6EbXRNnh1jTVq/view?usp=sharing">
                Mod 1{" "}
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1ZrlKC_zLCEv3iR2Ty2IHCMrXskyuLyGA/view?usp=sharing">
                Mod 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1dtqwa00kVqd9kHUbDqvx4B-xCuhY49_4/view?usp=sharing">
                Mod 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1Hh0WNokFFyT7_MQNUtNQFzuI4peI0i48/view?usp=sharing">
                Mod 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1v1ikGTM_IH9Ac8ThlWUaIS0dMZR_6qZv/view?usp=sharing">
                Mod 5
              </a>

              <br />

              <a href="https://drive.google.com/file/d/1WoiINKN3u70X8FtSRbWFDEIQdjtizzLr/view?usp=sharing">
                Lab Manual
              </a>
              
              <br />
              <a
                href="https://drive.google.com/file/d/11D6btKv6pL4OVHbcR5u8IftVDtoRD6bi/view?usp=sharing"
                target="_blank"
              >
                solved Q&N
              </a>
            </div>
          </Typography>

          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>

              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B0072I28TY&asins=B0072I28TY&linkId=0d7af94d0c626cbbc31d1bb9217f9929&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=817808046X&asins=817808046X&linkId=dddff665ac276204047594ab64f8a3f2&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>

            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>DATA MINING</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              Notes <br />
              <a href="https://drive.google.com/file/d/1u3He-6GSnL8Ug9rsZUpdP3vCKjEjGJKD/view?usp=sharing">
                Mod 1{" "}
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1flSTqnGcG3v2n-Zm4VUskXUVYwt7wsRV/view?usp=sharing">
                Mod 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1OGERtCdjO4L4AvEtWfN2FWvxSyOtlPM7/view?usp=sharing">
                Mod 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1lRkaH7fNoGy2A23PmVv_8cGHVRt1CBOi/view?usp=sharing">
                Mod 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/12I5b1mUyg5o4EBv0BR645RULDUycgi3P/view?usp=sharing">
                Mod 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>

              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=B075GB7FT5&asins=B075GB7FT5&linkId=4b3fbaafc8ffbb5c4966bd3332190d07&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>

            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>

              <iframe style={{ width: '120px', height: '240px' }} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-in.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=IN&source=ac&ref=qf_sp_asin_til&ad_type=product_link&tracking_id=viewnotes19-21&marketplace=amazon&region=IN&placement=0123814790&asins=0123814790&linkId=c03ef5f30c0ebbd157f118344b3fe8cb&show_border=false&link_opens_in_new_window=false&price_color=333333&title_color=0066c0&bg_color=ffffff">
              </iframe>

            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <Footer />
    </div>
  );
}
